import { Component, OnInit, ViewEncapsulation, Inject, Renderer2, ChangeDetectorRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NgForm } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Chart, registerables } from 'chart.js';
declare var $: any;


@Component({
  selector: 'app-wishsipthankyou',
  templateUrl: './wishsipthankyou.component.html',
  styleUrls: ['./wishsipthankyou.component.css']
})
export class WishsipthankyouComponent  implements OnInit {
  
  currentCalculator: 'sip' | 'lumsum' = 'sip';

  Monthly_investment: any = 25000;
  monthlyexpect: any = 12;
  timeperiod: any = 10;
  P: number = 25000;
  R: number = 12;
  T: number = 10;
  calculate_value: any;
  total_value: any;
  total_investment_ammount: number = 0;
  estmated_return = 0;
  amount_errormsg: string = '';
  Expected_Rate_error: string = '';
  Time_period_error: string = '';
  checkedTerms: string = 'true';
  
  L_Monthly_investment: any = 1000000;
  L_monthlyexpect: any = 12;
  L_timeperiod: any = 10;

  LP: number = 1000000;
  LR: number = 12;
  LT: number = 10;
  L_calculate_value: any;
  L_total_value: any;
  L_total_investment_ammount: number = 0;
  L_estmated_return = 0;
  L_amount_errormsg: string = '';
  L_Expected_Rate_error: string = '';
  L_Time_period_error: string = '';

  newChartData: any[] = [];
  public chartType = 'doughnut';
  public chartData = [1804160, 2500000];
  public chartLabels = ['Principal Amount', 'Interest Amount'];
  public chartColors = [
    {
      backgroundColor: ['#ED1C24', '#FFC4C7'],
    },
  ];
  public chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
  };



  L_newChartData: any[] = [];
  public L_chartType = 'doughnut';
  public L_chartData = [1804160, 2500000];
  public L_chartLabels = ['Principal Amount', 'Interest Amount'];
  public L_chartColors = [
    {
      backgroundColor: ['#ED1C24', '#FFC4C7'],
    },
  ];
  public L_chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
  };

  constructor(@Inject(DOCUMENT) private document: Document, private route: ActivatedRoute, private service: DataService, private titleService: Title, private metaService: Meta, private renderer: Renderer2, private cdr: ChangeDetectorRef, private router: Router) {
    Chart.register(...registerables);
  }

  ngOnInit(): void {
    this.currentCalculator = 'sip';;
    this.calculation()
    this.calculation2();

    if (window.location.hash === '#calculator') {
      this.currentCalculator = 'sip';

      // Wait for DOM to render after setting currentCalculator
      setTimeout(() => {
        const el = document.getElementById('sipSection');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 300); // Slight delay to ensure section is available
    }

    $('input[type="range"]').each(() => {
      $(this)[0].oninput = function () {
        var uMaxVal = $(this).attr('max');
        var uMinVal = $(this).attr('min'),
          uValu = this.value,
          // uCalc = (uValu * 100) / uMaxVal;
          uCalc = ((uValu - uMinVal) / (uMaxVal - uMinVal)) * 100;
        this.inflationrange = uValu.toString();
        $(this).siblings('.type-range').css('width', uCalc + '%');
        $(this).siblings('.thumb').css('left', uCalc + '%');
        if ($(this).parent().hasClass('retirement-custom-range')) {
          $(this).siblings('.thumbNew').text('');
        }
        if ($(this).parent().hasClass('retireCalc')) {
          $(this).siblings('.thumbNew').text(uValu + " ");
        }

      }
    });
    // document.getElementById("error_msg")!.style.display = "none";
    // document.getElementById("error_msg1")!.style.display = "none";
    // document.getElementById("error_msg2")!.style.display = "none";
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.currentCalculator === 'sip') {
        this.createChart(this.chartData);
      } else {
        this.createChart2(this.L_chartData);
      }
    }, 0);
  }

  showCalculator(type: 'sip' | 'lumsum'): void {
    this.currentCalculator = type;
    this.cdr.detectChanges(); // Ensure the view updates
    setTimeout(() => {
      if (type === 'sip') {
        this.createChart(this.chartData);
      } else {
        this.createChart2(this.L_chartData);
      }
    }, 0);
  }



  updateChartData(newData: number[]) {
    this.newChartData = newData;
    this.createChart(this.chartData);
  }


  updateChartData2(L_newData: number[]) {
    this.L_newChartData = L_newData;
    this.createChart(this.L_chartData);
  }

  createChart(chartDataSet: any) {
    const ctx: any = (document.getElementById('myChart') as HTMLCanvasElement).getContext('2d');
    var existingChart = Chart.getChart(ctx);

    // If an existing chart is found, destroy it
    if (existingChart) {
      existingChart.destroy();
    }

    const myChart = new Chart(ctx, {
      type: 'doughnut', // Replace with the desired chart type
      data: {
        // labels: ['Principal Amount', 'Interest Amount'],
        datasets: [
          {
            // label: 'My Dataset',
            data: chartDataSet,
            backgroundColor: ['#ED1C24', '#FFC4C7'],
            borderColor: ['#ED1C24', '#FFC4C7'],
            borderWidth: 1
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        // hover: {
        //   mode: 'nearest',
        //   intersect: true,
        // },
        // animation: {
        //   animateScale: true,
        //   animateRotate: false,
        // },
        tooltips: {
          callbacks: {
            label: function (tooltipItem: any, data: any) {
              return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              // return label.toLocaleString(); // Format with commas
            },
            formatter: function (value: any, context: any) {
              return value.toString();
            }
          }
        }
      } as any
    });
  }


  createChart2(L_chartDataSet: any) {
    const ctx: any = (document.getElementById('myChart') as HTMLCanvasElement).getContext('2d');
    var L_existingChart = Chart.getChart(ctx);

    // If an existing chart is found, destroy it
    if (L_existingChart) {
      L_existingChart.destroy();
    }

    const myChart = new Chart(ctx, {
      type: 'doughnut', // Replace with the desired chart type
      data: {
        // labels: ['Principal Amount', 'Interest Amount'],
        datasets: [
          {
            // label: 'My Dataset',
            data: L_chartDataSet,
            backgroundColor: ['#ED1C24', '#FFC4C7'],
            borderColor: ['#ED1C24', '#FFC4C7'],
            borderWidth: 1
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        // hover: {
        //   mode: 'nearest',
        //   intersect: true,
        // },
        // animation: {
        //   animateScale: true,
        //   animateRotate: false,
        // },
        tooltips: {
          callbacks: {
            label: function (tooltipItem: any, data: any) {
              return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              // return label.toLocaleString(); // Format with commas
            },
            formatter: function (value: any, context: any) {
              return value.toString();
            }
          }
        }
      } as any
    });
  }



  setInvestmentValue(event: any) {
    let val = event.target.value;
    document.getElementById("error_msg")!.style.display = "none";
    if (val < 500) {
      val = 500;
      this.amount_errormsg = "Minimum value allowed is 500";
      document.getElementById("error_msg")!.style.display = "block";
    } else if (val > 200000) {
      val = 200000;
      // this.amount_errormsg = "Maximum value allowed is 2,00,000";
      // document.getElementById("error_msg").style.display = "block";
    }

    this.P = val;
    var maxval = $('#monthlyRange').attr('max');
    var minval = $('#monthlyRange').attr('min');
    $('#monthlyRange').siblings('.thumb').css('left', ((val - minval) / (maxval - minval)) * 100 + '%');
    $('#monthlyRange').siblings('.type-range').css('width', ((val - minval) / (maxval - minval)) * 100 + '%');
  }

  setInvestmentValue2(event: any) {
    let val = event.target.value;
    document.getElementById('error_msg')!.style.display = 'none';
    if (val < 500) {
      val = 500;
      this.L_amount_errormsg = 'Minimum value allowed is 500';
      document.getElementById('error_msg')!.style.display = 'block';
    } else if (val > 2000000) {
      val = 2000000;
    }

    this.LP = val;
    var maxval = $('#monthlyRange').attr('max');
    var minval = $('#monthlyRange').attr('min');
    $('#monthlyRange')
      .siblings('.thumb')
      .css('left', ((val - minval) / (maxval - minval)) * 100 + '%');
    $('#monthlyRange')
      .siblings('.type-range')
      .css('width', ((val - minval) / (maxval - minval)) * 100 + '%');
  }


  setRateValue(event: any) {
    let val = event.target.value;
    document.getElementById("error_msg1")!.style.display = "none";
    if (val < 1) {
      val = 1;
      document.getElementById("error_msg1")!.style.display = "block";
      this.Expected_Rate_error = " Minimum value allowed is 1%";
    }
    else if (val > 30) {
      val = 30;
      // this.Expected_Rate_error =  "Maximum value allowed is 20%"
      // document.getElementById("error_msg1").style.display = "block";
    }

    this.R = val;
    var maxval = $('#monthlyrate').attr('max');
    var minval = $('#monthlyrate').attr('min');
    $('#monthlyrate').siblings('.thumb').css('left', ((val - minval) / (maxval - minval)) * 100 + '%');
    $('#monthlyrate').siblings('.type-range').css('width', ((val - minval) / (maxval - minval)) * 100 + '%');
  }


  setRateValue2(event: any) {
    let val = event.target.value;
    document.getElementById("error_msg1")!.style.display = "none";
    if (val < 1) {
      val = 1;
      document.getElementById("error_msg1")!.style.display = "block";
      this.L_Expected_Rate_error = " Minimum value allowed is 1%";
    }
    else if (val > 30) {
      val = 30;
    }

    this.LR = val;
    var maxval = $('#monthlyrate').attr('max');
    var minval = $('#monthlyrate').attr('min');
    $('#monthlyrate').siblings('.thumb').css('left', ((val - minval) / (maxval - minval)) * 100 + '%');
    $('#monthlyrate').siblings('.type-range').css('width', ((val - minval) / (maxval - minval)) * 100 + '%');
  }

  setTimeValue(event: any) {
    let val = event.target.value;
    document.getElementById("error_msg2")!.style.display = "none";
    if (val < 1) {
      this.Time_period_error = "Minimum value allowed is 1 year";
      document.getElementById("error_msg2")!.style.display = "block";
      val = 1;
    }
    else if (val > 30) {
      val = 30;
      // this.Time_period_error = "Maximum value allowed is 30 year";
      // document.getElementById("error_msg2").style.display = "block";
    }

    this.T = val;
    var maxval = $('#timerange').attr('max');
    var minval = $('#timerange').attr('min');
    $('#timerange').siblings('.thumb').css('left', ((val - minval) / (maxval - minval)) * 100 + '%');
    $('#timerange').siblings('.type-range').css('width', ((val - minval) / (maxval - minval)) * 100 + '%');
  }


  setTimeValue2(event: any) {
    let val = event.target.value;
    document.getElementById("error_msg2")!.style.display = "none";
    if (val < 1) {
      this.L_Time_period_error = "Minimum value allowed is 1 year";
      document.getElementById("error_msg2")!.style.display = "block";
      val = 1;
    }
    else if (val > 30) {
      val = 30;
    }

    this.LT = val;
    var maxval = $('#timerange').attr('max');
    var minval = $('#timerange').attr('min');
    $('#timerange').siblings('.thumb').css('left', ((val - minval) / (maxval - minval)) * 100 + '%');
    $('#timerange').siblings('.type-range').css('width', ((val - minval) / (maxval - minval)) * 100 + '%');
  }

  preventInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    // const value = inputElement.value;
    // const maxVal = inputElement.max;
    const value = parseInt(inputElement.value);
    const maxVal = parseInt(inputElement.max);
    if (value > maxVal) {
      inputElement.value = maxVal.toString();
    }
  }

  calculation() {
    // this.Monthly_investment = this.Monthly_investment ? this.Monthly_investment : 500;
    const P = this.P ? this.P : 500;
    // this.timeperiod = this.timeperiod ? this.timeperiod : 1;
    const T = this.T ? this.T : 1;
    // this.monthlyexpect = this.monthlyexpect ? this.monthlyexpect : 1;
    const R = this.R ? this.R : 1;

    const monthlyRate = R / 1200;
    const totalMonths = T * 12;
    this.total_investment_ammount = (P * totalMonths);
    this.calculate_value = Math.round(P * (Math.pow(1 + monthlyRate, totalMonths) - 1) / (monthlyRate) * (1 + monthlyRate));
    this.estmated_return = this.calculate_value - this.total_investment_ammount;
    this.chartData = [this.estmated_return, this.total_investment_ammount];
  }


  calculation2() {
    const P = this.LP ? this.LP : 500;
    const T = this.LT ? this.LT : 1;
    const R = this.LR ? this.LR : 1;

    // const monthlyRate = R ;
    const monthlyRate = R * 0.01;

    const timePeriod = T;
    this.L_total_investment_ammount = this.LP ? this.LP : 500;
    this.L_calculate_value = Math.round(P * Math.pow(1 + monthlyRate, T));
    // this.calculate_value = Math.round(P * (Math.pow(1 + monthlyRate, timePeriod) - 1) / (monthlyRate) * (1 + monthlyRate));
    this.L_estmated_return = this.L_calculate_value - this.L_total_investment_ammount;
    // this.chartData = [this.estmated_return,this.total_investment_ammount ];

    this.L_chartData = [this.L_estmated_return, this.L_total_investment_ammount];
    // console.log(this.chartData,'chartData');
  }

  monthlyInvestmentRangeVal() {
    this.P = this.Monthly_investment;
    document.getElementById("error_msg")!.style.display = "none";
  }

  monthlyInvestmentRangeVal2() {
    this.LP = this.L_Monthly_investment;
    document.getElementById("error_msg")!.style.display = "none";
  }
  monthlyTimeRangeVal() {
    this.T = this.timeperiod;
    document.getElementById("error_msg2")!.style.display = "none";
  }

  monthlyTimeRangeVal2() {
    this.LT = this.L_timeperiod;
    document.getElementById("error_msg2")!.style.display = "none";
  }
  monthlyRateRangeVal() {
    this.R = this.monthlyexpect;
    document.getElementById("error_msg1")!.style.display = "none";
  }

  monthlyRateRangeVal2() {
    this.LR = this.L_monthlyexpect;
    document.getElementById("error_msg1")!.style.display = "none";
  }

  chartHovered(event: any) {

  }

  scrolltop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.router.navigateByUrl('/wish-karo-sip-karo-vis');
  }

}

